import React, { memo, useCallback } from 'react';

import { Avatar, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getPersonInitials } from 'utils/loanApplication';

import {
  activeAuthorChipStyles,
  authorChipStyles,
  chipNameStyles,
  filterWrapperStyles,
  getChipAvatarBorderStyles,
} from './PendingChangesAuthorFilter.styles';

const PendingChangesAuthorFilter = ({
  authors,
  selectedAuthorKeys,
  authorColorMap,
  isDisabled = false,
  onAuthorToggle,
}) => {
  const onAuthorClick = useCallback(
    event => {
      if (isDisabled) {
        return;
      }

      onAuthorToggle(event.currentTarget.dataset.author);
    },
    [isDisabled, onAuthorToggle],
  );

  if (!authors.length) {
    return null;
  }

  return (
    <Box sx={filterWrapperStyles}>
      {authors.map(author => {
        const isSelected = selectedAuthorKeys.includes(author.key);
        const nameParts = (author.formattedFullName || '').split(' ');

        const initials = getPersonInitials({
          firstName: nameParts[0] || '',
          lastName: nameParts.slice(1).join(' ') || '',
        });

        const chipStyles = isSelected ? activeAuthorChipStyles : authorChipStyles;
        const avatarBorderStyles = getChipAvatarBorderStyles(authorColorMap[author.key]);

        return (
          <Box data-author={author.key} key={author.key} sx={chipStyles} onClick={onAuthorClick}>
            <Avatar sx={avatarBorderStyles}>{initials}</Avatar>
            <Typography sx={chipNameStyles} variant="medium12">
              {author.formattedFullName}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

PendingChangesAuthorFilter.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      formattedFullName: PropTypes.string,
    }),
  ).isRequired,
  selectedAuthorKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  authorColorMap: PropTypes.object.isRequired,
  onAuthorToggle: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default memo(PendingChangesAuthorFilter);
